import React from 'react'
import './User_SetLogoState.css'
import '../UserPanel.css'
import User_SetLogoState_Card from "./User_SetLogoState_Card";
import agent from "../../../agent";
import {IMAGE_MIME_TYPES} from "../../../constants/Constants";
class User_SetLogoState extends React.Component{

    constructor() {
        super();
        this.state = {
            votes: null,
            currentUserImage: null,
            filename: ""
        }
        this.voteRequestInterval = null;
    }
    componentDidMount() {
        this.getVotes();
        this.voteRequestInterval = setInterval(this.getVotes.bind(this), 5000);
        document.body.classList.add("app-overflow-y");
    }
    componentWillUnmount() {
        clearInterval(this.voteRequestInterval);
        document.body.classList.remove("app-overflow-y");
    }
    getVotes(){
        agent.Game.getVotes(this.props.player.teamID, (response) => {
            this.setState({
                votes: response
            })
        });
    }
    sendVote(playerID){
        console.log(playerID)
        agent.Game.setVote(this.props.game.uuid, playerID, (response)=>{
            console.log(response)
            this.getVotes();
        });
    }
    uploadImage(e){
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];
        reader.readAsDataURL(file)
        if(IMAGE_MIME_TYPES.includes(file.type)){
            reader.onloadend = () => {
                console.log(file);

                agent.Game.sendImage(this.props.player.playerID, file, (response)=> {
                    console.log(response);
                    this.setState({
                        filename: file.name
                    })
                });
            }
        }
        else{
            this.handleError("Вы можете загрузить только изображение");
        }



    }
    handleError(message){
        this.props.onError(message);
    }
    render() {
        let logoCards = [];
        let users =  this.props.team.users.sort((x, y)=> {
            return x.uuid === this.props.player.playerID ? -1 :
            y.uuid === this.props.player.playerID ? 1 : 0 });
        for (let i = 0; i < users.length; i++){
            let user = users[i];
            let votes = null;
            if(this.state.votes && this.state.votes[user.uuid]){
                votes = this.state.votes[user.uuid];
            }
            logoCards.push( <User_SetLogoState_Card key={i} user={user}
                                                    votes={votes}
                                                    isCurrentPlayer={user.uuid === this.props.player.playerID}
                                                    currentPlayerId={this.props.player.playerID}
                                                    onCardClick={this.sendVote.bind(this)}/>)
        }
        let uploadLogoText =  this.state.filename === "" ? 'Загрузите файл' : this.state.filename;
        return <div className="user-set-logo-status-container">
            <div className='user-header-text'>Логотип</div>
            <div className='user-set-logo-tooltip'>
                Загрузите Ваш вариант логотипа,
                обсудите с командой, какой подходит больше, и проголосуйте.
                <br/>
                <br/>
                Сообщите преподавателю, как будете готовы.
            </div>
            <div className='user-set-logo-tooltip-file-size'>
                Файл в формате JPG или PNG, размером не более 1 Мб
            </div>
            <div className='user-set-logo-tooltip-file-button'>
                <input type='file' id="file" className='user-set-logo-input-file' onChange={this.uploadImage.bind(this)}>
                </input>
                <label htmlFor='file' className='main-btn'>{uploadLogoText}</label>
            </div>
            <div className='user-set-logo-cards-container'>
                {logoCards}
            </div>
        </div>
    }
}

export default User_SetLogoState;
